import {createApi} from "@reduxjs/toolkit/query/react";
import customFetchBase from "../../../principal/customFetchBase";

export const administrativoApi = createApi({
    reducerPath: "administrativoApi",
    baseQuery: customFetchBase,
    tagTypes: ["Administrativo"],
    endpoints: () => ({})
});
